var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArcEdWordmarkBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2 -2 358 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#161616"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 94 L38.6 4 L45.4 4 L81.5 94 L71.3 94 L42 21 L12.7 94 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 4 L105 4 A29.5 29.5 0 0 1 122.3 57.4 L118.9 47.9 A20 20 0 0 0 105 13.5 L73 13.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.9 94 L105.5 54.5 L113.6 49.5 L138.9 94 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-9,0)",
    d: "M232.7 23.4 A42 45 0 1 0 227.9 81.6 L223.8 71.8 A32.5 35.5 0 1 1 226.8 32 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6,0)",
    d: "M240 4 H292 V13.5 H249.5 V44.8 H287 V54.3 H249.5 V84.5 H292 V94 H240 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-8,0)",
    d: "M305 66.5 A28 28 0 1 1 361 66.5 A28 28 0 1 1 305 66.5 Z M314.5 66.5 A18.5 18.5 0 1 0 351.5 66.5 A18.5 18.5 0 1 0 314.5 66.5 Z M351.5 4 H361 V94 H351.5 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcEdWordmarkBlack);
export default __webpack_public_path__ + "static/media/ARC-Ed-Wordmark-Black.bbc04f7515511449836e6e10ad998fbf.svg";
export { ForwardRef as ReactComponent };